// Copyright (c) 2019 Deere & Company

import EditableField from './editable-field';
import LabeledFormInput from './labeled-form-input';
import PropTypes from 'prop-types';
import React from 'react';

const LabeledInput = ( {
    className, highlightClass, isEditable, value, formatter, label, isRequired, type = 'text', vsrMessage, ...props
} ) => (
    <LabeledFormInput
        className={`${className} ${highlightClass}`}
        label={label}
        isRequired={isRequired}
    >
        <EditableField
            isEditable={isEditable}
            value={formatter ? formatter( value ) : value}
        >
            <input
                {...props}
                onChange={props.onChange}
                type={type}
                value={value}
                disabled={props.disabled}
            />
        </EditableField>
    </LabeledFormInput>
);

LabeledInput.displayName = 'LabeledInput';
LabeledInput.propTypes = {
    className: PropTypes.string,
    formatter: PropTypes.func,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    type: PropTypes.string,
    value: PropTypes.oneOfType( [PropTypes.string, PropTypes.number] ),
    vsrMessage: PropTypes.string,
    isRequired: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default LabeledInput;
